import { z } from 'zod';
export const passengerBonSchema = z.object({
    passengerId: z.string(),
    bonAmount: z.number().int().min(1), // in cents
    bonNumber: z.string(),
});
export const downloadBonInvoiceSchema = z.object({
    invoiceNumber: z.string().optional(),
    passengerBons: z.array(passengerBonSchema).min(1),
});
export const conditionsPreviewSchema = z.object({
    accountCode: z.string().optional(),
    airlineIataCode: z.string().optional(),
    cabin: z.string().optional(),
    destinationIata: z.string().optional(),
    originIata: z.string().optional(),
    outboundDepartureDate: z.string().optional(),
    tripType: z.enum(['multi-destination', 'one-way', 'round-trip']).optional(),
    xRoles: z.array(z.string()).optional(),
});
export const installmentPreviewSchema = z.object({
    accountCode: z.string().optional(),
    arrivalIataCode: z.string().optional(),
    companyIataCode: z.string().optional(),
    departureDate: z.string(),
    departureIataCode: z.string().optional(),
    fareValidityDeadline: z.string().optional(),
    passengerCount: z.coerce.number(),
    refundAllowed: z.boolean(),
    refundFee: z.coerce.number(),
    seatCode: z.string().optional(),
    ticketingDeadline: z.string().optional(),
    totalPriceCents: z.coerce.number(),
    xRoles: z.array(z.string()).optional(),
});
